import { useQuery } from '@tanstack/react-query';

import { agentWebhookLogsApi } from '../services/agentWebhookLogsApi';

const agentWebhookLogsKeys = {
  all: ['agent-webhook-logs'] as const,
  logs: (webhookId: string, query?: Record<string, unknown>) =>
    [...agentWebhookLogsKeys.all, 'list', webhookId, query] as const,
  stats: (webhookId: string) =>
    [...agentWebhookLogsKeys.all, 'stats', webhookId] as const,
};

export const useAgentWebhookLogs = (
  webhookId: string,
  query?: { page?: number; limit?: number },
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: agentWebhookLogsKeys.logs(webhookId, query),
    queryFn: () => agentWebhookLogsApi.getLogs(webhookId, query),
    enabled: (options?.enabled ?? true) && !!webhookId,
    staleTime: 30 * 1000, // 30 segundos - logs mudam frequentemente
  });
};

export const useAgentWebhookLogStats = (
  webhookId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: agentWebhookLogsKeys.stats(webhookId),
    queryFn: () => agentWebhookLogsApi.getStats(webhookId),
    enabled: (options?.enabled ?? true) && !!webhookId,
    staleTime: 30 * 1000,
  });
};
